<template>
    <div>
        <div v-for="section in sections" :key="section.id" class="scenario-section">
        <div v-if="section.title" class="slot-lab">{{ section.title }}</div>
        <div v-if="section.subtitle" :class="['sub-lab', section.subtitleClass]">
            {{ section.subtitle }}
        </div>
        <div :class="['list', { tight: section.tight }]">
            <StarterPackScenarioItem
                v-for="scenario in section.scenarios"
                :key="scenario.scenarioId"
                :scenario="scenario"
                :role-labels="roleLabels"
                :launching="launching"
                :can-save-settings="canSaveSettings"
                :scenarios="allScenarios"
                @configure="$emit('configure', scenario)"
                @launch="$emit('launch', scenario)"
                @disable="$emit('disable', scenario)"
                @locked-click="$emit('locked-click')"
            />
        </div>
        </div>
    </div>
</template>

<script>
import StarterPackScenarioItem from './StarterPackScenarioItem.vue'

export default {
    name: 'StarterPackScenarioSections',
    components: { StarterPackScenarioItem },
    props: {
        sections: {
            type: Array,
            required: true,
        },
        roleLabels: {
            type: Object,
            required: true,
        },
        launching: {
            type: Boolean,
            default: false,
        },
        canSaveSettings: {
            type: Boolean,
            default: false,
        },
        allScenarios: {
            type: Array,
            default: () => [],
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/vars.sass';

.slot-lab {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 14px;
    color: $muted-light-new;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.slot-lab::after {
    flex: 1;
    height: 1px;
    background: $border-new;
    content: '';
}

.sub-lab {
    display: flex;
    align-items: center;
    gap: 9px;
    margin: 0 0 12px 1px;
    color: $dark-new;
    font-family: Geologica, Inter, system-ui, sans-serif;
    font-size: 12.5px;
    font-weight: 800;
    letter-spacing: 0.01em;
}

.sub-lab::before {
    width: 13px;
    height: 13px;
    border-radius: 5px;
    background: #c7cdda;
    content: '';
}

.sub-lab.admin::before {
    background: $role-blue-new;
}

.sub-lab.master::before {
    background: $role-green-new;
}

.list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 36px;
    min-width: 0;
}

.list.tight {
    margin-bottom: 22px;
}
</style>
